module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0014.jpg?v=3cda4dda";